import React from 'react';

import {AsyncComponent} from "../../../../../core/components/router/async-component";

export const SideBarModuleAsyncComponent = AsyncComponent(async () => import('./side-bar-module' /* webpackChunkName: "side-bar-module" */ ));

export const SideBarModuleAsync = (props) => {
  return <SideBarModuleAsyncComponent {...props}/>
};
